import request from '@/utils/request'

export interface ProjectTrendsParamsType {
  // userName: string
  // password: string
}

// 项目动态
export async function projectTrends(params: ProjectTrendsParamsType) {
  return request('/api/project/trends', {
    method: 'POST',
    data: params
  })
}
